import { useTranslation } from 'react-i18next';
import { ReactComponent as CloseIcon } from 'theme/assets/icons/Cross.svg';
import LoadingIcon from 'theme/components/LoadingIcon/LoadingIcon';
import { useHistoryStore } from '../../store/history/historyStore';
import { useGetHistoricEntries, useHideModal } from '../../store/history/historyActions';
import HistoryItem from '../HistoryItem/HistoryItem';
import './HistoryModal.scss';

const HistoryModalWrapper = () => {
  const open = useHistoryStore((s) => s.open);
  if (!open) return null;
  return <HistoryModal />;
};

export const HistoryModal = () => {
  const close = useHideModal();
  const { t } = useTranslation();
  return (
    <>
      <div className='history-modal-overlay' />
      <div className='history-modal-position'>
        <div className='history-modal'>
          <div className='history-modal-header' onClick={close}>
            <div className='history-modal-header__text'>{t('my-history')}</div>
            <div className='history-modal-header__icon-container'>
              <CloseIcon className='history-modal-header__icon' />
            </div>
          </div>
          <div className='history-modal-content'>
            <ModalStates />
          </div>
        </div>
      </div>
    </>
  );
};

const ModalStates = () => {
  const { t } = useTranslation();
  const { isFetching, isError, data } = useGetHistoricEntries();

  if (isError) return <div className='history-modal-message'>{t('history-modal-error')}</div>;

  if (isFetching)
    return (
      <div className={'history-modal-loading'}>
        <LoadingIcon />
      </div>
    );

  if (!data) return null;

  if (data.entries.length === 0) return <div className='history-modal-message'>{t('history-modal-no-history')}</div>;

  return (
    <>
      {data.entries.map((entry, index) => (
        <HistoryItem key={index} startOpen={false} entry={entry} />
      ))}
    </>
  );
};

export default HistoryModalWrapper;
